module.exports = __webpack_public_path__ + "img/icon_e65.bc71ba31.png";